/**
 * @license @tabler/icons-solidjs v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createSolidComponent from '../createSolidComponent.js';

var IconTrash = createSolidComponent("outline", "trash", "Trash", [["path", { "d": "M4 7l16 0" }], ["path", { "d": "M10 11l0 6" }], ["path", { "d": "M14 11l0 6" }], ["path", { "d": "M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" }], ["path", { "d": "M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" }]]);

export { IconTrash as default };
//# sourceMappingURL=IconTrash.js.map
